import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoop = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8799 17.5H6.76987C5.73987 17.5 4.74987 17.09 4.01987 16.36C3.28987 15.63 2.87988 14.64 2.87988 13.61V9.5C2.87988 8.7 3.19989 7.94 3.75989 7.38C4.31989 6.82 5.07988 6.49999 5.87988 6.48999",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8799 14.5L13.8799 17.5L10.8799 20.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.87988 6.48999H17.4799C18.3799 6.48999 19.2399 6.85999 19.8799 7.48999C20.5199 8.12999 20.8799 8.99001 20.8799 9.89001V14.48C20.8799 15.28 20.5599 16.04 19.9999 16.6C19.4399 17.16 18.6799 17.48 17.8799 17.49",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8701 9.5L9.87012 6.5L12.8701 3.48999",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgLoop;
